import { getCookies } from "../helpers/commonFunctions";
import axios, { AxiosResponse, AxiosError } from "axios";

async function AxiosRequest<T>(
  url: string,
  method: "GET" | "POST" | "PUT" | "DELETE",
  body?: any,
  token?: string
): Promise<AxiosResponse<T>> {
  try {
    const headers = token ? await getHeaders(token) : {};
    const data = { ...body, form: "UpsellingV3" };
    const response = await axios.request<T>({
      url,
      method,
      headers,
      data,
    });
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      console.error("Axios Error:", axiosError.message);
      throw new Error(axiosError.message);
    } else {
      console.error("General Error:", error);
      throw new Error("General Error");
      // handleToast("error", 2000);
    }
  }
}

async function getHeaders(authToken: string) {
  const cookiesData = getCookies();

  //   const token = await generateToken();
  // in order
  // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdDAiOjE3MDEwMDI1MzgsImF1ZCI6ImRlc2t0b3AiLCJzdWIiOjY4NjU5MDUyLCJybmQiOiI1MTUxMzgxMSIsImV4cCI6MTcwMTAwMjg3NH0.qOV587dKYrOCgl9vNLe0BE49wvcSJW5HxR98er01im0";
  const token = authToken;
  const defaultHeaders = {
    source: cookiesData.source ?? "desktop",
    "accept-language": cookiesData.NEXT_LOCALE ?? "ar",
    "session-id": cookiesData.userInfo.id,
    country: cookiesData.ecountry ?? "jo",
    "x-tracking-uuid": cookiesData.device_uuid,
    "Content-Type": "application/json",
  };

  return {
    ...(token
      ? {
          Authorization: "Bearer " + token,
        }
      : {}),
    ...defaultHeaders,
  };
}

export default AxiosRequest;
